import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Container, Box } from '@mui/material';
import { BASIC_BORDER_COLOR } from '../../themes/tokens';

const customShouldForwardProp = (prop: string) => !['isTop'].includes(prop);

export const ControlBarWrapper = styled(Box, { shouldForwardProp: customShouldForwardProp })<{
  isTop?: boolean;
}>`
  button:not([data-id='kpi-formulas']) {
    padding: 9px 14px 9px 16px;
    border-radius: 8px;
    line-height: 16px;
    font-size: 15px;

    svg {
      padding-right: 6px;
    }
  }

  background-color: #ffffff;

  ${({ isTop }) =>
    isTop
      ? css`
          border-bottom: 1px solid ${BASIC_BORDER_COLOR};

          button:not([data-id='kpi-formulas']) {
            color: black;
            padding: 0;
            font-size: 24px;
            line-height: 24px;
            font-weight: 400;

            svg {
              padding: 0;
            }
          }
        `
      : css`
          border-top: 1px solid ${BASIC_BORDER_COLOR};
          position: sticky;
          bottom: 0;
          z-index: 1;
        `}
`;
export const ControlBarContainer = styled(Container)`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: flex-start;
`;

export const ControlBarBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
`;

export const ControlBarTitleBox = styled(Box)`
  display: flex;
  gap: 16px;
`;

export const ControlBarButtonsBox = styled(Box)`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;
`;
